export enum DocumentType {
  PolicyPack = 'PolicyPack',
  SI = 'SI',
  PDS = 'PDS',
  AF = 'AF',
}
